var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip",class:[
		!!_vm.scan ? 'tooltip--scan tooltip--scan-' + _vm.scan : '',
		'tooltip--' + _vm.placement
	],style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.content)}})}
var staticRenderFns = []

export { render, staticRenderFns }